import { useDispatch, useSelector } from "react-redux"
import { setSitu } from "./../store.js"
import { Stack, Form, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './ChatStart.css';


function ChatStart() {
  const navigate = useNavigate();
	let dispatch = useDispatch()
  let situNum = useSelector((state) => state.situNum ) //聊天情景设置


  return (
    <div className="ChatStart">
      <Form className="userForm">
        <Col>
            <Form.Group as={Row} className="mb-3" controlId="">
            <Col sm>
              <Form.Label className="formTitle">想进行什么对话？</Form.Label>
              <p className="formDesc">请选择下面其中一个情景或告诉我你想要的情景！</p>
              <Stack gap={2} className="example">
                <Stack direction="horizontal" gap={3}>
                  <button className="exampleBox" onClick={() =>{ dispatch(setSitu(0)); console.log(situNum); navigate('/chatWithTutor'); }}>📚请帮我学习OPIC！</button>
                  <button className="exampleBox" onClick={() =>{ dispatch(setSitu(1)); navigate('/chatWithTutor'); }}>☕与久别的外国朋友</button>
                  <button className="exampleBox" onClick={() =>{ dispatch(setSitu(2)); navigate('/chatWithTutor'); }}>💬与公司同事闲聊！</button>
                </Stack>
                <Stack direction="horizontal" gap={3} className="exampleContainer">
                  <button className="exampleBox" onClick={() =>{ dispatch(setSitu(3)); navigate('/chatWithTutor'); }}>📈用英语进行的公司面试</button>
                  <button className="exampleBox" onClick={() =>{ dispatch(setSitu(4)); navigate('/chatWithTutor'); }}>💘心动的相亲模拟！</button>
                  <button className="exampleBox" onClick={() =>{ dispatch(setSitu(5)); navigate('/chatWithTutor'); }}>🤝什么？要与外资公司开商务会议？</button>
                </Stack>
              </Stack>
            </Col>
            </Form.Group>

            <button className="mainBtn" onClick={() =>{ navigate('/chatSituation')                }}>
              我想要的情景这里没有...
            </button>
        </Col>
      </Form>
    </div>
    
  );
}

export default ChatStart;